// Shared HTML-escaping for the pure string-render layer (no DOM). Kept in its own module so
// both render.ts and icons.ts can use it without an import cycle.
export function escapeHtml(s: string): string {
  return s.replace(
    /[&<>"']/g,
    (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!
  );
}
